import { AppAlert } from '@components/antd';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import PreferredContactMethodModal from '../../modal/modal-preferred-contact';
import { usePreferredContact } from './hooks/use-preferred-contact';

export const PreferredContactBanner = () => {
  const { t } = useTranslation();
  const {
    open,
    handleOpen,
    handleClose,
    control,
    selectedMethods,
    setValue,
    onSubmit,
    clearErrors,
    errors,
    trigger,
    handleLater,
  } = usePreferredContact();
  return (
    <>
      <AppAlert
        showIcon
        type="warning"
        message={
          <p>
            {t('to_help_us_assist_you_more_quickly_add_your_phone_preferred_support_method')}
            <Button className="cursor-pointer mx-2.5! text-xs! h-[25.5px]! px-5! rounded-sm!" onClick={handleLater}>
              {t('later')}
            </Button>
            <Button
              className="cursor-pointer text-xs! h-[25.5px]! px-[5px]! rounded-sm! bg-text-950! text-white!"
              onClick={handleOpen}
            >
              {t('add_details')}
            </Button>
          </p>
        }
      />
      <PreferredContactMethodModal
        open={open}
        onClose={handleClose}
        control={control}
        selectedMethods={selectedMethods}
        setValue={setValue}
        trigger={trigger}
        onSubmit={onSubmit}
        clearErrors={clearErrors}
        errors={errors}
      />
    </>
  );
};
